import React, { useEffect, useState } from 'react'; // Importa React, useEffect y useState
import { getDataWhereId } from 'src/hooks/structureTable';
import { TextField } from '@mui/material'; // Importa TextField desde Material-UI
import esArray from 'src/general_components/functionEsArray';

export const ComprobantesExtraData = ({ data }) => {
    const [transformedData, setTransformedData] = useState([]); // Utiliza useState para manejar transformedData


    const normalizeFilter = (obj) => {
        if (!obj || typeof obj !== "object") return null;

        const keys = Object.keys(obj);
        if (keys.length === 0) return null;

        const key = keys[0];
        const value = obj[key];

        // Caso 1: ya viene con estructura correcta
        if (typeof value === "object" && value.field && value.value) {
            return obj; // lo devolvemos igual
        }

        // Caso 2: viene como { flete: "1" }
        return {
            [key]: {
                field: key,
                value: value
            }
        };
    };

    useEffect(() => {
        const transformData = async (data) => {
            try {
                const transformItem = async (item) => {
                    const extraData = normalizeFilter(JSON.parse(item.extra_data.replace(/'/g, '"')));
                    console.log('Extra Data original:', extraData);
                    const transformedData = {};
                    const promises = [];
                    
                    for (let key in extraData) {
                        const label = key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
                        const field = extraData[key].field;
                        let value = extraData[key].value;
                        const esNumber = parseInt(value);
                        console.log('Procesando campo:', field, 'con valor:', value);
                        if (field.startsWith('id_') && !isNaN(esNumber)) {
                            const fieldName = field.replace('id_', '');
                            const datosPromise = getDataWhereId(fieldName, field, extraData[key].value);
                            promises.push(
                                (async () => {
                                    try {
                                        const data = await datosPromise;
                                        value = data.nombre || data.descripcion || data.detalle || data.label || data.numero_comprobante || 'Sin datos';
                                        transformedData[label] = { field, value };
                                    } catch (error) {
                                        console.error('Error al obtener datos:', error);
                                    }
                                })()
                            );
                        } else {
                            transformedData[label] = { field, value };
                        }
                    }

                    await Promise.all(promises);
                    return transformedData;
                };

                const transformedDataArray = await Promise.all(esArray(data).map(transformItem));
                setTransformedData(transformedDataArray); // Actualiza el estado con los datos transformados
            } catch (error) {
                console.error('Error al transformar los datos:', error);
                throw error; // Propaga el error hacia arriba para que pueda ser capturado por el llamador
            }
        };

        // Llama a la función transformData cuando data cambia
        transformData(data);
    }, [data]); // Ejecuta el efecto solo cuando data cambia

    return (
        <div>
            {transformedData.map((item, index) => (
                <div key={index}>
                    {Object.entries(item).map(([label, { field, value }]) => (
                        <div key={field}>
                            <TextField
                                label={label}
                                value={value}
                                fullWidth
                                variant="outlined"
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </div>
                    ))}
                    <hr />
                </div>
            ))}
        </div>
    );
};